module.exports = __webpack_public_path__ + "img/Premier.295ed3b8.png";